import LabelledElement from "./LabelledElement";
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
} from "@mui/material";
import * as staticDataService from "services/staticDataService";

const ExposureFlagSelect = ({ options, value, onChange, isDisabled }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      size={"small"}
      disabled={isDisabled}
    >
      <MenuItem value={""}>&nbsp;</MenuItem>
      {options.map((option, index) => (
        <MenuItem key={index} value={option.key}>
          {option.display}
        </MenuItem>
      ))}
    </Select>
  );
};

const ExposureFlagCheckbox = ({ label, value, onChange }) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={value} onChange={onChange} />}
      label={label}
    />
  );
};

const Placeholder = () => {
  return (
    <Stack sx={{ marginTop: "8px", marginBottom: "15px" }}>
      <Skeleton width={140} sx={{ marginBottom: "0.375rem" }} />
      <Skeleton variant={"rounded"} sx={{ width: "100%", height: "40px" }} />
    </Stack>
  );
};

const ExposureFlagElement = ({ type, label, value, onChange }) => {
  const {
    data: config,
    isLoading: isConfigLoading,
  } = staticDataService.useConfigQuery("flags");

  const flagConfig =
    (config?.defaultExposureFlags ?? []).filter(
      (flag) => flag.type === type
    )?.[0] ?? {};

  if (flagConfig.categoryType === "boolean") {
    return (
      <ExposureFlagCheckbox
        label={flagConfig.displayName}
        value={value ?? false}
        onChange={(e) => onChange(e.target.checked)}
      />
    );
  } else if (flagConfig.categoryType === "select") {
    return (
      <LabelledElement label={label}>
        <ExposureFlagSelect
          options={flagConfig?.categoryOptions ?? []}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          isDisabled={isConfigLoading}
        />
      </LabelledElement>
    );
  }

  return <Placeholder />;
};

export default ExposureFlagElement;
